var _path, _path2, _path3, _path4, _path5, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _line14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 91,
    viewBox: "0 0 328 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.75 85.957C160.537 85.9746 161.703 84.6973 161.703 83.0977C161.703 81.457 160.443 80.2852 158.938 80.2852C158.023 80.2852 157.244 80.7012 156.758 81.4102H156.652C156.646 79.3652 157.484 78.1758 158.879 78.1758C159.822 78.1758 160.396 78.7383 160.59 79.4883H161.633C161.416 78.1582 160.373 77.2383 158.879 77.2383C156.887 77.2383 155.656 78.9199 155.656 81.9258C155.656 85.0664 157.279 85.9395 158.75 85.957ZM156.793 83.1211C156.805 82.1191 157.66 81.2168 158.773 81.2109C159.881 81.2168 160.678 82.0664 160.684 83.1094C160.678 84.1641 159.846 85.0254 158.75 85.0312C157.613 85.0254 156.799 84.1172 156.793 83.1211ZM166.196 79.1719V77.2734H165.282V79.1719C165.271 81.1465 163.987 83.1387 162.435 83.8477L163.021 84.6211C164.239 84.0059 165.265 82.6875 165.745 81.1172C166.243 82.5996 167.269 83.8359 168.458 84.4102L169.021 83.6836C167.485 82.9863 166.191 81.0762 166.196 79.1719ZM170.157 86.8125H171.083V76.3711H170.157V86.8125Z",
    fill: "#3A3A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7266 85.957C86.4199 85.957 87.6855 84.9258 87.6797 83.5312C87.6855 82.4531 87.0176 81.6621 85.9102 81.4922V81.4336C86.8008 81.1816 87.3633 80.4785 87.3516 79.5117C87.3633 78.2988 86.3789 77.2383 84.7617 77.2383C83.2559 77.2383 82.002 78.1406 81.9492 79.4883H82.9688C83.0156 78.6562 83.8418 78.1582 84.75 78.1523C85.7168 78.1582 86.3379 78.7207 86.332 79.5703C86.3379 80.4434 85.6172 81.0234 84.5859 81.0234H83.8945V81.9492H84.5859C85.9043 81.9551 86.6426 82.6055 86.6484 83.5312C86.6426 84.416 85.834 85.0195 84.7148 85.0195C83.7012 85.0195 82.8984 84.5156 82.8398 83.707H81.7734C81.8262 85.0547 83.0391 85.957 84.7266 85.957ZM92.2432 79.1719V77.2734H91.3292V79.1719C91.3175 81.1465 90.0343 83.1387 88.4815 83.8477L89.0675 84.6211C90.2862 84.0059 91.3116 82.6875 91.7921 81.1172C92.2901 82.5996 93.3155 83.8359 94.505 84.4102L95.0675 83.6836C93.5323 82.9863 92.2374 81.0762 92.2432 79.1719ZM96.2042 86.8125H97.13V76.3711H96.2042V86.8125Z",
    fill: "#3A3A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.762 77.2383C231.846 77.2324 230.551 78.4746 230.551 80.1797C230.562 81.7617 231.688 82.9102 233.211 82.9102C234.154 82.9102 234.992 82.4648 235.391 81.7148H235.461C235.455 83.4082 234.846 84.4453 233.691 84.4453C233.012 84.4453 232.525 84.0762 232.379 83.4492H230.645C230.814 84.8848 231.986 85.957 233.691 85.957C235.824 85.957 237.189 84.2578 237.184 81.375C237.184 78.293 235.52 77.2441 233.762 77.2383ZM232.273 80.1328C232.262 79.2891 232.906 78.627 233.773 78.6211C234.641 78.627 235.273 79.3125 235.285 80.1211C235.285 80.9355 234.623 81.6211 233.762 81.6211C232.889 81.6211 232.273 80.9707 232.273 80.1328ZM241.888 78.668V77.0742H240.376V78.668C240.37 80.7363 239.462 82.7812 237.599 83.5664L238.501 84.8086C239.802 84.2168 240.675 83.0566 241.155 81.6152C241.642 82.9336 242.485 84 243.704 84.5508L244.583 83.3555C242.773 82.5879 241.882 80.625 241.888 78.668ZM245.157 86.9414H246.669V76.2539H245.157V86.9414Z",
    fill: "#3A3A3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57422 85.957C10.4551 85.957 11.5391 84.375 11.5391 81.5977C11.5391 78.8438 10.4375 77.2383 8.57422 77.2383C6.70508 77.2383 5.60352 78.8438 5.60938 81.5977C5.60352 84.375 6.69336 85.957 8.57422 85.957ZM6.62891 81.5977C6.63477 79.4004 7.35547 78.1582 8.57422 78.1523C9.79297 78.1582 10.5137 79.4004 10.5078 81.5977C10.5137 83.7949 9.79883 85.0195 8.57422 85.0195C7.34375 85.0195 6.63477 83.7949 6.62891 81.5977ZM15.9854 79.1719V77.2734H15.0714V79.1719C15.0597 81.1465 13.7765 83.1387 12.2237 83.8477L12.8097 84.6211C14.0284 84.0059 15.0538 82.6875 15.5343 81.1172C16.0323 82.5996 17.0577 83.8359 18.2472 84.4102L18.8097 83.6836C17.2745 82.9863 15.9796 81.0762 15.9854 79.1719ZM19.9464 86.8125H20.8722V76.3711H19.9464V86.8125Z",
    fill: "#3A3A3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M306.797 77.3555H305.73L303.621 78.7617V79.8281L305.684 78.457H305.73V85.8398H306.797V77.3555ZM308.771 85.8398H314.278V84.9023H310.235V84.832L312.181 82.8281C313.681 81.2812 314.12 80.543 314.126 79.5938C314.12 78.2754 313.03 77.2383 311.489 77.2383C309.954 77.2383 308.794 78.2461 308.806 79.7461H309.802C309.808 78.7969 310.441 78.1582 311.454 78.1523C312.409 78.1582 313.136 78.7207 313.142 79.5938C313.136 80.3789 312.655 80.9531 311.653 82.0195L308.759 85.0664L308.771 85.8398ZM318.854 79.1719V77.2734H317.94V79.1719C317.928 81.1465 316.645 83.1387 315.092 83.8477L315.678 84.6211C316.897 84.0059 317.922 82.6875 318.403 81.1172C318.901 82.5996 319.926 83.8359 321.115 84.4102L321.678 83.6836C320.143 82.9863 318.848 81.0762 318.854 79.1719ZM322.815 86.8125H323.74V76.3711H322.815V86.8125Z",
    fill: "#3A3A3A"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 39.5,
    y1: 56.8398,
    x2: 39.5,
    y2: 64.8398,
    stroke: "#929292"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 64.5,
    y1: 56.8398,
    x2: 64.5,
    y2: 64.8398,
    stroke: "#929292"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 114.5,
    y1: 56.8398,
    x2: 114.5,
    y2: 64.8398,
    stroke: "#929292"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 189.5,
    y1: 56.8398,
    x2: 189.5,
    y2: 64.8398,
    stroke: "#929292"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 264.5,
    y1: 56.8398,
    x2: 264.5,
    y2: 64.8398,
    stroke: "#929292"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 139.5,
    y1: 56.8398,
    x2: 139.5,
    y2: 64.8398,
    stroke: "#929292"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: 56.8398,
    x2: 165,
    y2: 66.8398,
    stroke: "#929292",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 56.8398,
    x2: 90,
    y2: 66.8398,
    stroke: "#929292",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 56.8398,
    x2: 240,
    y2: 66.8398,
    stroke: "#929292",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 214.5,
    y1: 56.8398,
    x2: 214.5,
    y2: 64.8398,
    stroke: "#929292"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 289.5,
    y1: 56.8398,
    x2: 289.5,
    y2: 64.8398,
    stroke: "#929292"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 315,
    y1: 56.8398,
    x2: 315,
    y2: 66.8398,
    stroke: "#929292",
    strokeWidth: 2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 56.8398,
    x2: 15,
    y2: 66.8398,
    stroke: "#929292",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 34.8398,
    width: 8,
    height: 22,
    rx: 1,
    fill: "#FDDEB9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 34.8398,
    width: 8,
    height: 22,
    rx: 1,
    fill: "#FDDEB9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 9.83984,
    width: 8,
    height: 47,
    rx: 1,
    fill: "#FDDEB9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 0.839844,
    width: 8,
    height: 56,
    rx: 1,
    fill: "#F15454"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 6.83984,
    width: 8,
    height: 50,
    rx: 1,
    fill: "#FDDEB9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 34.8398,
    width: 8,
    height: 22,
    rx: 1,
    fill: "#FDDEB9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 34.8398,
    width: 8,
    height: 22,
    rx: 1,
    fill: "#FDDEB9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 23.8398,
    width: 8,
    height: 33,
    rx: 1,
    fill: "#FDDEB9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 23.8398,
    width: 8,
    height: 33,
    rx: 1,
    fill: "#FDDEB9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 23.8398,
    width: 8,
    height: 33,
    rx: 1,
    fill: "#FDDEB9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 34.8398,
    width: 8,
    height: 22,
    rx: 1,
    fill: "#FDDEB9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 34.8398,
    width: 8,
    height: 22,
    rx: 1,
    fill: "#FDDEB9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 34.8398,
    width: 8,
    height: 22,
    rx: 1,
    fill: "#FDDEB9"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    y1: 56,
    x2: 328,
    y2: 56,
    stroke: "#929292",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.3e35a3981aa44c578e3904a531af547f.svg";
export { ForwardRef as ReactComponent };